import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/header/styles.scss';export default {
  "header": "_header_bmk9r_1",
  "label": "_label_bmk9r_32",
  "icon": "_icon_bmk9r_39"
};